import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav2").addClass("active");
var history = new Swiper(".section2 .mySwiper", {
	navigation: {
	  	nextEl: ".section2 .swiper-button-next",
	  	prevEl: ".section2 .swiper-button-prev",
	},
	breakpoints: {
        320: { //当屏幕宽度大于等于320
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: '3.63%',
        },
        1280: { //当屏幕宽度大于等于1280
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: '7.27%',
        }
    },
});
var honor = new Swiper(".section3 .mySwiper", {
	slidesPerView: 3,
    loop:true,
    speed:1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
	breakpoints: {
        320: { //当屏幕宽度大于等于320
			slidesPerView: 1,
			slidesPerGroup: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
        },
        1280: { //当屏幕宽度大于等于1280
			slidesPerView: 3,
        }
    },
});